// @spec VUL-STR-062
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { AuditReportPage } from '@/features/vulnerabilities/pages/AuditReportPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/vulnerabilities/audit-report')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditReport'),
  }),
  component: AuditReportPage,
});
